
$(function() {
    let body = $("body");
    body.bind('mouseup touchend', function (e) {
        var container = $('#contact-select');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.options').addClass('options--fade-out');
            $('#contact-select .select').removeClass('hover');
        }
    });
    body.on('click','#contact-select',function(){
        $('.options').toggleClass('options--fade-out');
    })
    body.on('click','.options li',function(e){

        if(!$(this).hasClass("disabled")){
            let content = $(this).html();
            $(".select .label").html(content);

            let selected = null

            $("#contact-select-select option").map((index,option) => {
                const optionValue = $(option).val();
                if(optionValue.toString().trim() === content.toString().trim()){

                    selected = $(option);
                }
            } );
            if(!!selected){
                $('#contact-select-select option:selected').removeAttr('selected');
                console.log("run here,",selected);
                selected.attr("selected","selected");
            }
        }else{
            e.stopPropagation();
        }
    });
    body.on("submit","#const-us-form",function(e){
        e.preventDefault();
        const errorClass = "error";
        let hasError = 0;
        /* Check input */
        $("input").each((index,input) =>{
            const $input = $(input);
            if($input.val() === ""){
                $input.addClass(errorClass);
                hasError++;
            }else{
                $input.removeClass(errorClass)
            }
        })
        /* Check select */
        const selectedOption = $("#contact-select option:selected").val();

        if(selectedOption === ""){
            $("#contact-select").addClass(errorClass);
            hasError++;
        }else{
            $("#contact-select").removeClass(errorClass);
        }
        /* Textarea */
        const textarea = $( "textarea[name='message']" );

        if(textarea.val() === ""){
            textarea.addClass(errorClass);
            hasError++;
        }else{
            textarea.removeClass(errorClass);
        }


        if(hasError === 0){
            e.currentTarget.submit();
        }

    })
});

